var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.loading)?_c('div',[_c('Loading')],1):_c('div',[_c('Navbar'),_c('v-main',{staticStyle:{"padding-top":"0px !important"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }